<template>
    <div>
        <!-- 此组件为递归组件 -->
        <el-collapse v-model="activeNames" style="border:none">
            <template v-for="(element,index) in jsonData">
                <!-- 栅格布局解析区域 -->
                <template v-if="element.type == 'grid' && !element.options.isvisible && permissionSetting(element.options.invisibleRoleList,'look') && !element.options.isvisible && !componentsIsShow(element,element.options.hideCondition)">
                    <el-collapse-item :key="index" :title="element.name" :name="element.name" v-if="element.name">
                        <el-row :key="element.key" :gutter="element.options.gutter" :justify="element.options.justify" :align="element.options.align" v-if="!element.options.hidden" :class="element.options.customClass">
                            <el-col v-for="(val, idx) in element.columns" :span="val.span" :key="idx">
                                <childrecursiveComponent :jsonData='val.list' :childData="childData" :childDetailJson="childDetailJson" :childindex="childindex" :childName="childName" :currentChild="currentChild" :parentRowData="parentRowData"></childrecursiveComponent>
                            </el-col>
                        </el-row>
                    </el-collapse-item>
                    <el-row :key="element.key" :gutter="element.options.gutter" :justify="element.options.justify" :align="element.options.align" v-if="!element.options.hidden && !element.name" :class="element.options.customClass">
                        <el-col v-for="(val, idx) in element.columns" :span="val.span" :key="idx">
                            <childrecursiveComponent :jsonData='val.list' :childData="childData" :childDetailJson="childDetailJson" :childindex="childindex" :childName="childName" :currentChild="currentChild" :parentRowData="parentRowData"></childrecursiveComponent>
                        </el-col>
                    </el-row>
                </template>
              <!-- 基础组件解析区域 -->
                <template v-else>
                    <widget-form-item :key="element.key" :jsonData="jsonData[0]" :element="element" :index="index" :isChild='true' :childData="childData" :childDetailJson="childDetailJson" :childindex="childindex" :childName="childName" :currentChild="currentChild" :parentRowData="parentRowData"></widget-form-item>
                </template>
            </template>
        </el-collapse>
    </div>
</template>

<script>
import widgetFormItem from '@/components/customPagesOne/widgetFormItem.vue'
export default {
    name:"childrecursiveComponent",
    props:['jsonData','childData',"childDetailJson","childName","childindex","currentChild","parentRowData"],
    components:{widgetFormItem},
    data(){
        return{

        }
    },
    computed: {
        //详情页面分组信息
        activeNames: {
            // 计算属性的 getter
            get:function () {
                var arr = []
                this.jsonData.map((val)=>{
                    arr.push(val.name)
                })
                return arr
            },
            // 计算属性的 getter
            set: function() {}
        },
        //主表信息
        detailInfos() {
            return this.$store.state.detailInfo
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
    },
    methods:{
        //权限设置判断方法
        permissionSetting(arr, str) {
            if (!!arr && arr.length != 0) {
                var newArr = [];
                for (var i = 0; i < arr.length; i++) {
                    newArr.push(arr[i].name)
                }
                var res = newArr.includes(this.$store.state.currentuser.roleName)
                if (str == 'look') {
                    return !res
                } else {
                    return res
                }
            } else {
                if (str == 'look') {
                    return true
                } else {
                    return false
                }
            }
        },
        //组件禁用、隐藏条件解析
        componentsIsShow(element, hideCondition) {
            var str = hideCondition
            if (!!hideCondition) {
                var arr = hideCondition.split('&&')
                var Arr = arr.map((arrItem) => {
                    if (arrItem.indexOf('||') !== -1) {
                        return arrItem.split("||")
                    } else {
                        return arrItem
                    }
                })
                var newArr = Arr.flat(Infinity)
                newArr.forEach((newArrItem) => {
                    if (newArrItem.indexOf('(') !== -1) {
                        newArrItem = newArrItem.substr(1, newArrItem.length)
                        str = this.componentsIsShowDetailFunction(newArrItem,str,element)
                    } else if (newArrItem.indexOf(')') !== -1) {
                        newArrItem = newArrItem.substr(0, newArrItem.length - 1)
                        str = this.componentsIsShowDetailFunction(newArrItem,str,element)
                    }
                    str = this.componentsIsShowDetailFunction(newArrItem,str,element)
                })
                if (str.indexOf(':') == -1) {
                    return eval(str)
                }
            } else {
                return false
            }
        },
        componentsIsShowDetailFunction(newArrItem,str,element,){
            if (newArrItem.indexOf('!==') !== -1 && newArrItem.indexOf(':') !== -1) {
                var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('!==') - 1)
                var filedValue = newArrItem.substr(newArrItem.indexOf('!==') + 3, newArrItem.length)
                if (filedValue.indexOf('currentuser:') !== -1) {
                    filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
                }
                if (this.detailInfos[Detailfiled] != filedValue) {
                    str = str.replace(newArrItem, true)
                } else {
                    str = str.replace(newArrItem, false)
                }
            }else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') !== -1) {
                var Detailfiled = newArrItem.substr(1, newArrItem.indexOf('=') - 1)
                var filedValue = newArrItem.substr(newArrItem.indexOf('=') + 2, newArrItem.length)
                if (filedValue.indexOf('currentuser:') !== -1) {
                    filedValue = filedValue.replace(filedValue, this.currentuser[filedValue.substr(12, filedValue.length)])
                }
                if (!!this.detailInfos[Detailfiled] && this.detailInfos[Detailfiled] == filedValue) {
                    str = str.replace(newArrItem, true)
                } else {
                    str = str.replace(newArrItem, false)
                }
            } else if (newArrItem.indexOf(':') !== -1 && newArrItem.indexOf('==') == -1) {
                var Detailfiled = newArrItem.substr(newArrItem.indexOf(':') + 1, newArrItem.length)
                var replaceStr = newArrItem.substr(newArrItem.indexOf(':'), newArrItem.length)
                if (!!this.detailInfos[Detailfiled]) {
                    str = str.replace(replaceStr, true)
                } else {
                    str = str.replace(replaceStr, false)
                }
            }
            return str
        },
    }
}
</script>

<style>

</style>